module.exports = __webpack_public_path__ + "img/SamsungA30.0c0f5b6a.png";